// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import { createClientLogger } from '@azure/logger';

/**
 * @private
 */
export const chatStatefulLogger = createClientLogger('communication-react:chat-stateful');